export default __webpack_public_path__ + "static/logo_uzb_post-2x-0ed30b48fc36691337cf37695ec67912.png";